import React, { Fragment } from 'react';
import imag2 from './images/Programmer-rafiki.png';
import ButtonLink from './Button';
import '../styles/Intro.css'
const Intro = () => {
  return (
    <Fragment>
      
      <div className="intro-container">

        {/* Text and button section (responsive with flexbox) */}
        <div className="text-and-button">
         <p className='intro'>Hi there I am <br/>
         <span className='name'style={{color:"darkblue"}}> Rajiv Muddukuppam</span><br/>
         Passionate ReactJS Developer skilled in creating dynamic web applications and intuitive UI/UX designs. Adept at transforming complex ideas into innovative, user-friendly solutions.Experienced in building responsive, high-performance websites using modern web technologies.
        
         
         </p>
         {/* <nav>
            <a className='c-icon' href="https://www.linkedin.com/in/muddukuppam-rajiv-01604b267/" style={{color:'#0077B5'}} ><i class="fab fa-linkedin icons" style={{color:'#0077B5'}}></i></a>
            <a className='c-icon' href="https://github.com/rajivtheju"><i class="fab fa-github-square icons"style={{color:'#181717'}} ></i></a>
            <a className='c-icon' href="https://www.facebook.com/rajivtheju/"><i class="fab fa-facebook-square icons"style={{color:'#1877F2'}} ></i></a>
            <a className='c-icon' href="https://www.instagram.com/rajivtheju/"><i class="fab fa-instagram-square icons"style={{color:'#d62976'}} ></i></a>
          </nav> */}
         <button className='res'> <a href='https://drive.google.com/file/d/1J9TiEnkO_BJbfDk_1DDafLCTXh7cYDlM/view?usp=sharing' className='res-text'> Resume </a></button> 
         <button className='res'> <a href='mailto:rajivthejutheju@gmail.com' className='res-text'> Hire me </a></button> 
 
        </div>

         {/* Image section (responsive with flexbox) */}
         <div className="image-section">
          <img src={imag2} alt="Programmer Rafiki" className="logo2" />
        </div>
      </div>
    </Fragment>
  );
};

export default Intro;
